import queryString from "query-string";
import { msalInstance } from "../msalInstance";
import { loginRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

// ✅ Get MSAL token
async function getAuthHeader(): Promise<Record<string, string>> {
    try {
        const account = msalInstance.getActiveAccount();
        if (!account) return {};
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account,
        });
        return { Authorization: `Bearer ${response.accessToken}` };
    } catch (error) {
        console.error("Silent token acquisition failed", error);
        return {};
    }
}

// ✅ Generic fetch wrapper
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json() as Promise<T>;
    } catch (error) {
        console.error("API error:", error);
        throw error;
    }
}

// ✅ Fetch Menu
export const fetchMenu = async () => {
    const url = new URL(`${API_URL}/menu`);
    const { simulate_roles } = queryString.parse(window.location.search);
    if (simulate_roles) url.searchParams.append("simulate_roles", simulate_roles as string);

    return apiFetch(url.toString(), {
        mode: "cors",
        credentials: "include",
        headers: await getAuthHeader(),
    });
};

// ✅ Fetch Page
export const fetchPage = async (path: string) => {
    const url = new URL(`${API_URL}/page/${path}`);
    const { simulate_roles } = queryString.parse(window.location.search);
    if (simulate_roles) url.searchParams.append("simulate_roles", simulate_roles as string);

    return apiFetch(url.toString(), {
        mode: "cors",
        credentials: "include",
        headers: await getAuthHeader(),
    });
};

// ✅ Fetch User
export const fetchUser = async () => {
    const url = new URL(`${API_URL}/user`);

    const response = await apiFetch<any>(url.toString(), {
        mode: "cors",
        method: "GET",
        credentials: "include",
        headers: await getAuthHeader(),
    });

    return response.firstName && response;
};